import { render } from "./PpcCampaignGroupInfo.vue?vue&type=template&id=9d073a76&scoped=true"
import script from "./PpcCampaignGroupInfo.vue?vue&type=script&lang=js"
export * from "./PpcCampaignGroupInfo.vue?vue&type=script&lang=js"

import "./PpcCampaignGroupInfo.vue?vue&type=style&index=0&id=9d073a76&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d073a76"]])

export default __exports__